import { Component, contentChild, Signal } from '@angular/core';

import { LoadingIndicatorComponent } from './loading-indicator.component';

@Component({
  selector: 'td-wb-loading-indicator-panel',
  templateUrl: 'loading-indicator-panel.component.html',
  styleUrls: ['loading-indicator-panel.component.scss'],
  imports: [LoadingIndicatorComponent]
})
export class LoadingIndicatorPanelComponent {
  readonly customLoadingIndicator: Signal<LoadingIndicatorComponent | undefined> = contentChild(LoadingIndicatorComponent);
}
